import store from '../store';
import http from '../common/libs/http';
// import Vue from 'vue';

const sendRequest = async (method, api, body, headers, config) => {
	store.state.loading = true;
	if (body && body.bid) {
		if (body.bid === true) {
			if (store.state.bot) {
				body.bid = store.state.bot.id;
				body.locale = store.state.bot.locale;
			} else {
				delete body.bid;
			}
		}
	}

	headers = {
		...(store.state.auth_token ? { 'Authorization': 'Token ' + store.state.auth_token } : {}),
		...headers
	}


	let result;
	try {
		result = await http.sendRequest(method, api, body, headers, config);
	} catch (ex) {
		console.error(ex);
		// Vue.swal({
		// 	icon: 'error',
		// 	text: ex.message || (ex.statusText && `${ex.statusText}: ${ex.url}`) || ex
		// });
	} finally {
		store.state.loading = false;
	}

	return result;
};

export const post = async (api, body, headers, config) => await sendRequest('POST', api, body, headers, config);
export const get = async (api, body, headers, config) => await sendRequest('GET', api, body, headers, config);
export const put = async (api, body, headers, config) => await sendRequest('PUT', api, body, headers, config);
export const del = async (api, body, headers, config) => await sendRequest('DELETE', api, body, headers, config);
export const upload = async (api, file, headers, config) => await sendRequest('UPLOAD', api, file, headers, config);

export default {
	post,
	get,
	put,
	del,
	upload
};

